










import {
  computed,
  defineComponent,
  ref,
  useContext, watch
} from '@nuxtjs/composition-api';
import {findActiveCategory} from "~/modules/catalog/category/helpers/findActiveCategory";
import {useUrl} from "~/composables/Palmers";

export default defineComponent({
  name: 'ElementCategoryGrid',
  props: {
    element: {
      type: Object,
      require: true
    }
  },
  components: {
    CategoryGrid: () => import("~/components/Palmers/Category/CategoryGrid.vue")
  },
  setup(props) {
    const categoryWall = ref([]);
    const {getMediaUrl} = useUrl();

    //@ts-ignore
    const {$vsf, $pinia} = useContext();

    const categories = computed(() => $pinia.state.value.category?.rawCategories?.items[0])

    const buildCategoryWall = () => {
      let categoriesIds = props.element.categories;

      for (let c = 0; c < categoriesIds.length; c += 2) {
        //@ts-ignore
        const category1 = findActiveCategory(categories.value, parseInt(categoriesIds[c]), 'id');
        //@ts-ignore
        const category2 = findActiveCategory(categories.value, parseInt(categoriesIds[c + 1]), 'id');

        const categoryWallChild = [];

        if (category1) {
          categoryWallChild.push({
            ...category1,
            title: category1.name,
            subtitle: category1['short_description'],
            hover_text: category1['category_hover_text'],
            img_type: 'category_wall_2x2',
            image: (category1.image || $vsf.$magento.config.magentoBaseUrl),
            image_mobile: (category1['category_image_mobile'] ? getMediaUrl(category1['category_image_mobile']) : (category1.image || $vsf.$magento.config.magentoBaseUrl)),
            image_hover: (category1['category_image_hover'] ? getMediaUrl(category1['category_image_hover']) : (category1.image || $vsf.$magento.config.magentoBaseUrl)),
          });
        }

        if (category2) {
          categoryWallChild.push({
            ...category2,
            title: category2.name,
            subtitle: category2['short_description'],
            hover_text: category2['category_hover_text'],
            img_type: 'category_wall_2x3',
            image: (category2.image || $vsf.$magento.config.magentoBaseUrl),
            image_mobile: (category2['category_image_mobile'] ? getMediaUrl(category2['category_image_mobile']) : (category2.image || $vsf.$magento.config.magentoBaseUrl)),
            image_hover: (category2['category_image_hover'] ? getMediaUrl(category2['category_image_hover']) : (category2.image || $vsf.$magento.config.magentoBaseUrl)),
          });
        }

        if (categoryWallChild.length) {
          categoryWall.value.push(categoryWallChild);
        }
      }
    }

    if (categories.value) {
      buildCategoryWall()
    } else {
      watch(categories, () => buildCategoryWall())
    }

    return {
      categoryWall
    }
  }
});
